import React, { useContext, useState, useEffect, useRef } from 'react';
import {Table, Input,Form, Select,DatePicker} from 'antd';
import moment from "moment";

const {Option} = Select;
const EditableContext = React.createContext(null);
const EditableRow = ({ index, ...props }) => {
    const [form] = Form.useForm();
    return (
        <Form form={form} component={false}>
            <EditableContext.Provider value={form}>
                <tr {...props} />
            </EditableContext.Provider>
        </Form>
    );
};
let basic_info;
const EditableCell = ({
                          title,
                          editable,
                          children,
                          dataIndex,
                          record,
                          handleSave,
                          ...restProps
                      }) => {
    const [editing, setEditing] = useState(false);
    const inputRef = useRef(null);
    const selectRef = useRef(null);
    const datePickerRef = useRef(null);
    const form = useContext(EditableContext);
    useEffect(() => {
        if (editing) {
            if(dataIndex === "deleteStatus" || dataIndex === "claimType" || dataIndex === "salesOrg" || dataIndex === "salesOffice" || dataIndex === "status" || dataIndex === "claimCategory"){
                selectRef.current.focus()
            }else if(dataIndex === "pricingDate" || dataIndex === "reqDeliveryDate"){
                datePickerRef.current.focus()
            }else{
                inputRef.current.focus();
            }
        }
    }, [editing]);

    const toggleEdit = (values) => {
        setEditing(!editing);
        if(values.pricingDate || values.reqDeliveryDate){
            values.pricingDate && form.setFieldsValue({
                ["pricingDate"]:moment(new Date(values.pricingDate))
            })
            values.reqDeliveryDate && form.setFieldsValue({
                ["reqDeliveryDate"]:moment(new Date(values.reqDeliveryDate))
            })
        }else {
            form.setFieldsValue({
                [dataIndex]: record[dataIndex],
            });
        }
        // if(values.pricingDate || values.reqDeliveryDate){
        //
        // }else{
        //     form.setFieldsValue({
        //         [dataIndex]: record[dataIndex],
        //     });
        // }

    };
    const save = async () => {
        try {
            const values = await form.validateFields();
            if(values.pricingDate){
                values.pricingDate = values.pricingDate?moment(values.pricingDate).format('YYYY-MM-DD'):null
            }
            if(values.reqDeliveryDate){
                values.reqDeliveryDate = values.reqDeliveryDate?moment(values.reqDeliveryDate).format('YYYY-MM-DD'):null
            }
            toggleEdit(values);
            handleSave({ ...record, ...values });
        } catch (errInfo) {
            console.log('Save failed:', errInfo);
        }
    };

    let childNode = children;
    if (editable) {
        childNode = editing ? (
            <Form.Item
                style={{
                    margin: 0,
                }}
                name={dataIndex}
                rules={[
                    {
                        required: false,
                        message: `${title} is required.`,
                    },
                ]}
            >
                {dataIndex === "deleteStatus" ?
                    <Select ref={selectRef} onChange={save} onBlur={save}>
                        <Option value={0}> </Option>
                        <Option value={'X'}>X</Option>
                    </Select>
                    :dataIndex === "claimType"?
                        <Select style={{width:200}} placeholder={'Please select'} ref={selectRef} onChange={save} onBlur={save} showSearch optionFilterProp="children">
                            {
                                basic_info && basic_info.claimTypeList?basic_info.claimTypeList.map(item=>{
                                    return <Option value={item.TGT01}>{item.TGT01} | {item.TGT02}</Option>
                                }):''
                            }
                        </Select>
                    :dataIndex === "salesOrg"?
                        <Select placeholder={'Please select'} ref={selectRef} onChange={save} onBlur={save}>
                            {
                                basic_info && basic_info.salesOrgList?basic_info.salesOrgList.map(item=>{
                                    return <Option value={item.TGT02} >{item.TGT02}</Option>
                                }):''
                            }
                        </Select>
                    :dataIndex === "salesOffice"?
                        <Select placeholder={'Please select'} ref={selectRef} onChange={save} onBlur={save}>
                            {
                                basic_info && basic_info.salesOfficeList?basic_info.salesOfficeList.map(item=>{
                                    return <Option value={item.TGT02} >{item.TGT02}</Option>
                                }):''
                            }
                        </Select>
                    :dataIndex === "status"?
                        <Select placeholder={'Please select'} ref={selectRef} onChange={save} onBlur={save}>
                            {
                                basic_info && basic_info.statusList?basic_info.statusList.map(item=>{
                                    return <Option value={item.TGT01} >{item.TGT02}</Option>
                                }):''
                            }
                        </Select>
                    :dataIndex === "claimCategory"?
                        <Select placeholder={'Please select'} ref={selectRef} onChange={save} onBlur={save}>
                            {
                                basic_info && basic_info.claimCategoryList?basic_info.claimCategoryList.map(item=>{
                                    return <Option value={item.TGT01} >{item.TGT01}</Option>
                                }):''
                            }
                        </Select>
                    :dataIndex === "pricingDate" || dataIndex === "reqDeliveryDate"?
                        <DatePicker format={'YYYY-MM-DD'} ref={datePickerRef} onChange={save} onBlur={save} />
                    :dataIndex==="paymentTerm"?
                    <Input ref={inputRef} maxlength={4} onPressEnter={save} onBlur={save}/>
                    :dataIndex==="channel" || dataIndex==="division"?
                    <Input ref={inputRef} maxlength={2} onPressEnter={save} onBlur={save}/>
                    :dataIndex==="soldTo" || dataIndex==="billTo" || dataIndex==="shipTo" || dataIndex==="invoiceNo" || dataIndex==="postalCode"?
                    <Input ref={inputRef} maxlength={10} onPressEnter={save} onBlur={save}/>
                    :dataIndex==="currency" || dataIndex==="country"?
                    <Input ref={inputRef} maxlength={3} onPressEnter={save} onBlur={save}/>
                    :dataIndex==="billingInstruction" || dataIndex==="serialNumber"?
                    <Input ref={inputRef} maxlength={120} onPressEnter={save} onBlur={save}/>
                    :dataIndex==="lenovoRef"?
                    <Input ref={inputRef} maxlength={80} onPressEnter={save} onBlur={save}/>
                    :dataIndex==="poNumber"?
                    <Input ref={inputRef} maxlength={35} onPressEnter={save} onBlur={save}/>
                    :dataIndex==="bpRef" || dataIndex==="street2" || dataIndex==="city" || dataIndex==="contactPerson" || dataIndex==="endUserName"?
                    <Input ref={inputRef} maxlength={40} onPressEnter={save} onBlur={save}/>
                    :dataIndex==="street"?
                    <Input ref={inputRef} maxlength={60} onPressEnter={save} onBlur={save}/>
                    :dataIndex==="email"?
                    <Input ref={inputRef} maxlength={200} onPressEnter={save} onBlur={save}/>
                    :dataIndex==="phoneNo"?
                    <Input ref={inputRef} maxlength={30} onPressEnter={save} onBlur={save}/>
                    :dataIndex==="comment"?
                    <Input ref={inputRef} maxlength={360} onPressEnter={save} onBlur={save}/>
                    :dataIndex==="partNumber"?
                    <Input ref={inputRef} maxlength={18} onPressEnter={save} onBlur={save}/>
                    :
                    <Input ref={inputRef} onPressEnter={save} onBlur={save}/>
                }
            </Form.Item>
        ) : (
            <div
                className="editable-cell-value-wrap"
                style={{
                    paddingRight: 24,
                }}
                onClick={toggleEdit}
            >
                {children}
            </div>
        );
    }
    return <td {...restProps}>{childNode}</td>;
};

class EditableTable extends React.Component {
    constructor(props) {
        super(props);
        basic_info = JSON.parse(window.sessionStorage.getItem('basic_info'))?JSON.parse(window.sessionStorage.getItem('basic_info')):[]
        this.columns = [
            {
                title: 'Portal Claim Request ID',
                dataIndex: 'portalReqNo',
                width:210,
                sorter: {
                    compare: (a, b) => a.portalReqNo - b.portalReqNo,
                },
            },
            {
                title: 'Portal Claim Req Item No.',
                dataIndex: 'portalReqItem',
                width:150,
            },
            {
                title: 'Dispute No.',
                dataIndex: 'disputeNo',
                width:120,
            },
            {
                title: 'Dispute Item No.',
                dataIndex: 'disputeItemNo',
                width:150,
            },
            {
                title: 'Claim Request No.',
                dataIndex: 'claimReqNo',
                width:250,
                sorter: {
                    compare: (a, b) => a.claimReqNo - b.claimReqNo,
                },
            },
            {
                title: 'Claim ID',
                dataIndex: 'claimId',
                width:120,
                sorter: {
                    compare: (a, b) => a.claimId - b.claimId,
                },
            },
            {
                title: 'Claim Item No.',
                dataIndex: 'claimItemNo',
                width:140,
            },
            {
                title: <span><lable style={{color:'red'}}>*</lable>Sold To Party</span>,
                dataIndex: 'soldTo',
                width:180,
                editable: true,
                render:(text,record)=>{
                    if(text){
                        return <Input maxLength={10} value={text} disabled={record.claimReqNo} />
                    }else{
                        return <Input maxLength={10} />
                    }
                }
            },
            // {
            //     title: 'Customer Name',
            //     dataIndex: 'soldToText',
            // },
            {
                title: <span><lable style={{color:'red'}}>*</lable>Bill To Party</span>,
                dataIndex: 'billTo',
                width:180,
                editable: true,
                render:(text,record)=>{
                    if(text){
                        return <Input maxLength={10} value={text} disabled={record.claimReqNo} />
                    }else{
                        return <Input maxLength={10} />
                    }
                }
            },
            {
                title: 'Ship To Party',
                dataIndex: 'shipTo',
                width:180,
                editable: true,
                render:(text,record)=>{
                    if(text){
                        return <Input maxLength={10} value={text} disabled={record.claimReqNo} />
                    }else{
                        return <Input maxLength={10} />
                    }
                }
            },
            {
                title: 'Invoice No.',
                dataIndex: 'invoiceNo',
                width:180,
                editable: true,
                render:(text, record, index)=>{
                    if(text){
                        return <Input maxLength={10} value={text} />
                    }else{
                        return <Input maxLength={10} />
                    }
                }
            },
            {
                title: <span><lable style={{color:'red'}}>*</lable>Claim Type</span>,
                dataIndex: 'claimType',
                width:250,
                editable: true,
                render:(text, record, index)=>{
                    if(!text){
                        return 'Please select'
                    }else{
                        // return  basic_info.claimTypeList.map(item=>{
                        //     if(item.TGT01===text){
                        //         return item.TGT02
                        //     }
                        // })
                        return text
                    }
                }
            },
            // {
            //     title: 'Order Reason Description',
            //     dataIndex: 'claimTypeText',
            // },
            {
                title: <span><lable style={{color:'red'}}>*</lable>Claim Category</span>,
                dataIndex: 'claimCategory',
                width:150,
                editable: true,
                render:(text, record, index)=>{
                    if(!text){
                        return 'Please select'
                    }else{
                        return text
                    }
                }
            },
            {
                title: <span><lable style={{color:'red'}}>*</lable>Sales Org</span>,
                dataIndex: 'salesOrg',
                width:140,
                editable: true,
                render:(text, record, index)=>{
                    if(!text){
                        return 'Please select'
                    }else{
                        if(record.claimReqNo){
                            return <Input value={text} disabled={record.claimReqNo} />
                        }else{
                            return text
                        }
                    }
                }
            },
            {
                title: <span><lable style={{color:'red'}}>*</lable>Sales Office</span>,
                dataIndex: 'salesOffice',
                width:140,
                editable: true,
                render:(text, record, index)=>{
                    if(!text){
                        return 'Please select'
                    }else{
                        record.salesOffice=text
                        return text
                    }
                }
            },
            {
                title: <span><lable style={{color:'red'}}>*</lable>Channel</span>,
                dataIndex: 'channel',
                width:130,
                editable: true,
                render:(text,record)=>{
                    if(text){
                        return <Input maxLength={2} value={text} disabled={record.claimReqNo} />
                    }else{
                        return <Input maxLength={2} />
                    }
                }
            },
            {
                title: <span><lable style={{color:'red'}}>*</lable>Division</span>,
                dataIndex: 'division',
                width:130,
                editable: true,
                render:(text,record,index)=>{
                    if(text){
                        return <Input maxLength={2} value={text} disabled={record.claimReqNo} />
                    }else{
                        return <Input maxLength={2} />
                    }
                }
            },
            {
                title: <span><lable style={{color:'red'}}>*</lable>Pricing Date</span>,
                dataIndex: 'pricingDate',
                width:150,
                editable: true,
                render:(text, record, index)=>{
                    if(!text){
                        return 'Please select'
                    }else{
                        record.pricingDate= moment(new Date(text))
                        return moment(text).format('YYYY-MM-DD')
                    }
                }
            },
            {
                title: 'Requested Delivery Date',
                dataIndex: 'reqDeliveryDate',
                width:200,
                editable: true,
                render:(text, record, index)=>{
                    if(!text){
                        return 'Please select'
                    }else{
                        record.reqDeliveryDate= moment(new Date(text))
                        return moment(text).format('YYYY-MM-DD')
                    }
                }
            },
            {
                title: 'SBO-No/SOP Ref./LENOVO Ref',
                dataIndex: 'lenovoRef',
                width:250,
                editable: true,
                render:(text, record, index)=>{
                    if(text){
                        record.lenovoRef = text
                        return <Input maxLength={80} value={text} />
                    }else{
                        return <Input maxLength={80} />
                    }
                }
            },
            {
                title: 'BP-Reference',
                dataIndex: 'bpRef',
                width:250,
                editable: true,
                render:(text)=>{
                    if(text){
                        return <Input maxLength={40} value={text} />
                    }else{
                        return <Input maxLength={40} />
                    }
                }
            },
            {
                title: 'Customer PO No.',
                dataIndex: 'poNumber',
                width:250,
                editable: true,
                render:(text)=>{
                    if(text){
                        return <Input maxLength={35} value={text} />
                    }else{
                        return <Input maxLength={35} />
                    }
                }
            },
            {
                title: 'Street/House Number',
                dataIndex: 'street',
                width:250,
                editable: true,
                render:(text)=>{
                    if(text){
                        return <Input maxLength={60} value={text} />
                    }else{
                        return <Input maxLength={60} />
                    }
                }
            },
            {
                title: 'Street 2',
                dataIndex: 'street2',
                width:250,
                editable: true,
                render:(text)=>{
                    if(text){
                        return <Input maxLength={40} value={text} />
                    }else{
                        return <Input maxLength={40} />
                    }
                }
            },
            {
                title: 'Contact Country',
                dataIndex: 'country',
                width:150,
                editable: true,
                render:(text)=>{
                    if(text){
                        return <Input maxLength={3} value={text} />
                    }else{
                        return <Input maxLength={3} />
                    }
                }
            },
            {
                title: 'Postal Code',
                dataIndex: 'postalCode',
                width:150,
                editable: true,
                render:(text)=>{
                    if(text){
                        return <Input maxLength={10} value={text} />
                    }else{
                        return <Input maxLength={10} />
                    }
                }
            },
            {
                title: 'City',
                dataIndex: 'city',
                width:150,
                editable: true,
                render:(text)=>{
                    if(text){
                        return <Input maxLength={40} value={text} />
                    }else{
                        return <Input maxLength={40} />
                    }
                }
            },

            {
                title: 'Contact Person',
                dataIndex: 'contactPerson',
                width:150,
                editable: true,
                render:(text)=>{
                    if(text){
                        return <Input maxLength={40} value={text} />
                    }else{
                        return <Input maxLength={40} />
                    }
                }
            },
            {
                title: 'Email',
                dataIndex: 'email',
                width:250,
                editable: true,
                render:(text)=>{
                    if(text){
                        return <Input maxLength={200} value={text} />
                    }else{
                        return <Input maxLength={200} />
                    }
                }
            },
            {
                title: 'Phone Number',
                dataIndex: 'phoneNo',
                width:180,
                editable: true,
                render:(text)=>{
                    if(text){
                        return <Input maxLength={30} value={text} />
                    }else{
                        return <Input maxLength={30} />
                    }
                }
            },
            {
                title: 'Billing Instruction',
                dataIndex: 'billingInstruction',
                width:180,
                editable: true,
                render:(text,record)=>{
                    if(text){
                        return <Input maxLength={120} value={text} disabled={record.massUpload==='X'} />
                    }else{
                        return <Input maxLength={120} disabled={record.massUpload==='X'} />
                    }
                }
            },
            {
                title: 'Label',
                dataIndex: 'paymentTerm',
                width:150,
                editable: true,
                render:(text, record, index)=>{
                    if(text){
                        return <Input value={text} disabled={record.claimReqNo} />
                    }else{
                        return <Input disabled={record.claimReqNo} />
                    }
                }
            },
            {
                title: <span><lable style={{color:'red'}}>*</lable>Comment</span>,
                dataIndex: 'comment',
                width:250,
                editable: true,
                render:(text)=>{
                    if(text){
                        return <Input maxLength={360} value={text} />
                    }else{
                        return <Input maxLength={360} />
                    }
                }
            },
            {
                title: <span><lable style={{color:'red'}}>*</lable>Material</span>,
                dataIndex: 'partNumber',
                width:180,
                editable: true,
                render:(text)=>{
                    if(text){
                        return <Input maxLength={18} value={text} />
                    }else{
                        return <Input maxLength={18} />
                    }
                }
            },
            {
                title: <span><lable style={{color:'red'}}>*</lable>Quantity</span>,
                dataIndex: 'quantity',
                width:120,
                editable: true,
                render:(text)=>{
                    if(text){
                        return <Input value={text} />
                    }else{
                        return <Input />
                    }
                }
            },
            {
                title: 'End User Name',
                dataIndex: 'endUserName',
                width:200,
                editable: true,
                render:(text)=>{
                    if(text){
                        return <Input maxLength={40} value={text} />
                    }else{
                        return <Input maxLength={40} />
                    }
                }
            },
            {
                title: <span><lable style={{color:'red'}}>*</lable>Unit Claim Value</span>,
                dataIndex: 'unitClaimValue',
                width:150,
                editable: true,
                render:(text)=>{
                    if(text){
                        return <Input value={text} />
                    }else{
                        return <Input />
                    }
                }
            },
            {
                title: 'Claim Value',
                dataIndex: 'claimValue',
                width:150,
            },
            {
                title: <span><lable style={{color:'red'}}>*</lable>Currency</span>,
                dataIndex: 'currency',
                width:150,
                editable: true,
                render:(text,record)=>{
                    if(text){
                        return <Input maxLength={3} value={text} disabled={record.claimReqNo} />
                    }else{
                        return <Input maxLength={3} />
                    }
                }
            },
            {
                title: 'Serial Number',
                dataIndex: 'serialNumber',
                width:250,
                editable: true,
                render:(text, record, index)=>{
                    if(text){
                        return <Input maxLength={120} value={text} />
                    }else{
                        return <Input maxLength={120} />
                    }
                }
            },
            {
                title: 'Deletion Indicator',
                dataIndex: 'deleteStatus',
                width:150,
                editable: true,
                render:(text,record)=>{
                    if(!text){
                        return 'Please select'
                    }else {
                        if(text==='X'){
                            return 'X'
                        }else{
                            return ''
                        }
                    }
                }
            },
            {
                title: 'Created On',
                dataIndex: 'portalCreatedOn',
                width:150,
            },
            {
                title: 'Created by',
                dataIndex: 'portalCreatedBy',
                width:150,
            },
            {
                title: 'Changed On',
                dataIndex: 'portalChangedOn',
                width:150,
            },
            {
                title: 'Changed By',
                dataIndex: 'portalChangedBy',
                width:150,
            },
            {
                title: 'Status',
                dataIndex: 'statusText',
                width:250,
            },
            {
                title: 'Processing log',
                dataIndex: 'processingLog',
                width:250,
            },
        ];
        this.state = {
            selectedRowKeys:[],
            dataSource: this.props.dataSource,
            randomNumber: this.props.randomNumber,
            selectedRows:[]
        };
    }
    // handleDelete = (key) => {
    //     const dataSource = [...this.state.dataSource];
    //     this.setState({
    //         dataSource: dataSource.filter((item) => item.key !== key),
    //     });
    // };
    handleSave = (row) => {
        if(row.pricingDate){
            row.pricingDate = moment(row.pricingDate).format('YYYY-MM-DD')
        }
        if(row.reqDeliveryDate){
            row.reqDeliveryDate = moment(row.reqDeliveryDate).format('YYYY-MM-DD')
        }
        const newData = [...this.state.dataSource];
        const index = newData.findIndex((item) => row.id === item.id);
        const item = newData[index];
        newData.splice(index, 1, { ...item, ...row });
        let {selectedRows,selectedRowKeys}=this.state;
        let newRows=[];
        selectedRows && selectedRows.map(item=>{
            if(item.id===row.id){

            }else{
                newRows.push(item)
            }
        })
        this.setState({
            dataSource: [...newData],
            selectedRows:selectedRows?[...newRows,row]:''
        });

        let changeData=[];
        // [...newData,row].forEach((item_d,i)=>{
        //     if(item.id==item_d.id){
        //         [...newData,row].splice(i,1)
        //     }
        // })
        [...newData,row].map(item=>{
            if(item.id===row.id){

            }else{
                changeData.push({
                    ...item,
                    pricingDate:item.pricingDate?moment(item.pricingDate).format('YYYY-MM-DD'):null,
                    reqDeliveryDate: item.reqDeliveryDate?moment(item.reqDeliveryDate).format('YYYY-MM-DD'):null
                })
            }
        })
        console.log([...newRows,row])
        this.props.saveData([...newRows,row],[...changeData,row])

        // this.props.allData([...newData])
    };
    onSelectChange = (selectedRowKeys,selectedRows) => {
        // console.log('selectedRowKeys changed: ', selectedRowKeys);
        // console.log('selectedRows changed: ', selectedRows);
        this.setState({selectedRowKeys})
        this.setState({selectedRows:selectedRows})
        this.props.saveData(selectedRows)

    };
    static getDerivedStateFromProps(nextProps, prevState) {
        const {randomNumber,dataSource} = nextProps;
        if (randomNumber !== prevState.randomNumber) {
            return {
                randomNumber,
                dataSource,
                selectedRowKeys:[],
                selectedRows:[]
            };
        }
        return null;
    }
    render() {
        const { dataSource,selectedRowKeys } = this.state;
        const rowSelection = {
            selectedRowKeys,
            onChange: this.onSelectChange,
        };
        const components = {
            body: {
                row: EditableRow,
                cell: EditableCell,
            },
        };
        const columns = this.columns.map((col) => {
            if (!col.editable) {
                return col;
            }
            return {
                ...col,
                onCell: (record) =>{
                    if(col.dataIndex==="deleteStatus"){
                        return{
                            record,
                            editable:!record.deleteStatus,
                            dataIndex: col.dataIndex,
                            title: col.title,
                            handleSave: this.handleSave,
                        }
                    }else{
                        return{
                            record,
                            editable: !(col.dataIndex==="soldTo" && col.editable && record.claimReqNo || col.dataIndex==="soldTo" && col.editable && record.claimReqNo || col.dataIndex === "soldToText" && col.editable && record.claimReqNo || col.dataIndex === "billTo" && col.editable && record.claimReqNo || col.dataIndex === "shipTo" && col.editable && record.claimReqNo || col.dataIndex === "salesOrg" && col.editable && record.claimReqNo || col.dataIndex === "currency" && col.editable && record.claimReqNo || col.dataIndex === "division" && col.editable && record.claimReqNo || col.dataIndex === "channel" && col.editable && record.claimReqNo || col.dataIndex === "paymentTerm" && col.editable && record.claimReqNo || record.massUpload==='X' && col.dataIndex==="billingInstruction" && col.editable) ,
                            dataIndex: col.dataIndex,
                            title: col.title,
                            handleSave: this.handleSave,
                        }
                    }
                },
                // onCell: (record) => ({
                //     record,
                //     editable: col.editable,
                //     dataIndex: col.dataIndex,
                //     title: col.title,
                //     handleSave: this.handleSave,
                // }),
            };
        });
        return (
                <Table
                    scroll={{y: 500}}
                    components={components}
                    rowClassName={() => 'editable-row'}
                    bordered
                    rowKey={'id'}
                    dataSource={dataSource}
                    columns={columns}
                    // rowSelection={rowSelection}
                />
        );
    }
}
export default EditableTable;